import { Icon } from "@atoms"
import { faIcon } from "@utils/faIcon"

function Banner(props) {
    const { type, text, extraMargin=false } = props

    const typeIconMap = {
        "info": faIcon({ name: "circle-info", style: "solid" }),
        "success": faIcon({ name: "circle-check", style: "solid" }),
        "warning": faIcon({ name: "triangle-exclamation", style: "solid" }),
        "danger": faIcon({ name: "square-exclamation", style: "solid" }),
    }

    return (
        <div className={`banner banner--${type}${extraMargin ? " banner--with-extra-margin" : ""}`}>
            <div>{typeIconMap[type] && <Icon containerClassName="icon-inline" icon={typeIconMap[type]} />}</div>
            <div>{text}</div>
        </div>
    )
}

export default Banner;
